<template>
  <AuthMain>
    <v-progress-circular
      :size="70"
      :width="3"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </AuthMain>
</template>

<script>
  import AuthMain from '../Account/AuthMain.vue'
export default {
  components: {
    AuthMain
  },
  name: 'Index',
  created() {
    const {token, answer } = this.$route.params;
    if (! (token && answer)) {
      this.invalid = true;
    }
    const data = {
      data: {
        token,
        answer
      }
    }
    this.$store.dispatch('checkInvite', data);
  },
  data () {
    return {
      invalid: false
    }
  }
}
</script>

<style lang="css" scoped>
</style>